import React, { useEffect, useState } from 'react'
import BEMHelper from '@ynap/bem-helper'
import Flag from '@ynap/flag'
import { RadioButtonGroup, RadioButton } from '@ynap/radio-button'
import { CombinedSelect } from '@ynap/select'

const bem = new BEMHelper('CountryLanguageSection')

export const CountryLanguageSection = ({
    countries,
    messages,
    selectedCountry,
    selectedLanguage,
    onCountryChange,
    onLanguageChange,
}) => {
    const [countriesOptionsData, setCountryOptionsData] = useState([])

    const countryLanguages = (countries && countries[selectedCountry]?.languages) || {}
    const selectedCountryPreferredLanguage = countries?.[selectedCountry]?.preferredLanguage
    const languagesArr = Object.keys(countryLanguages)
        .sort()
        .map((lang) => countryLanguages[lang])
    // Country's default language should be the first option
    languagesArr.unshift(
        languagesArr.splice(
            languagesArr.findIndex((language) => language.iso === selectedCountryPreferredLanguage),
            1
        )[0]
    )

    useEffect(() => {
        const allCountriesKeys = Object.keys(countries)

        setCountryOptionsData(
            allCountriesKeys.map((iso) => ({
                value: countries[iso].countryCode,
                key: countries[iso].countryCode,
                label: (
                    <div className={bem('countryOptionContainer')}>
                        <Flag countryISO={countries[iso].countryCode} />
                        <span className={bem('flagLabel')}>{countries[iso].countryName}</span>
                    </div>
                ),
                labelNative: countries[iso].countryName,
            }))
        )
    }, [countries])

    return (
        <section className={bem()}>
            <h2 className={bem('countryLangSectionTitle')}>
                {messages.marketingPreferences.countryLangSectionTitle()}
            </h2>
            <p className={bem('countryLangSectionText')}>{messages.marketingPreferences.countryLangSectionText()}</p>

            <CombinedSelect
                type="defaultLink"
                className={bem('countrySelection')}
                value={selectedCountry}
                onChange={(value) => onCountryChange(value)}
                options={countriesOptionsData}
                emptyLabel={messages.marketingPreferences.emptyLabel()}
            />

            <RadioButtonGroup
                component={RadioButtonGroup}
                name="preferredMALang"
                id="preferredMALang"
                value={selectedLanguage}
            >
                {languagesArr.map((language) => {
                    const { locale, langDesc } = language || {}
                    return (
                        <RadioButton
                            key={locale}
                            value={locale}
                            label={langDesc}
                            onChange={() => onLanguageChange(locale)}
                        />
                    )
                })}
            </RadioButtonGroup>
        </section>
    )
}
